<script>
    import ExemptionLabel from 'views/components/exemptionLabel/ExemptionLabel.svelte'

    const {
        title,
    } = $props()
</script>

<span>
    {title}
    <ExemptionLabel></ExemptionLabel>
</span>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
span {
  display: flex;
  gap: 8px;
  align-items: center;
}</style>
